import React from 'react';
import { TransitionMotion, spring } from 'react-motion';

const fadeConfig = { stiffness: 400, damping: 100 };
const slideConfig = { stiffness: 330, damping: 66 };

const willEnter = () => ({
    opacity: 0,
    offset: -100,
});

const willLeave = () => ({
    opacity: spring(0, fadeConfig),
    offset: spring(-100, slideConfig),
});

const getStyles = () => ({
    opacity: spring(1, fadeConfig),
    offset: spring(0, slideConfig),
});

const RouteTransition = ({ children: child, pathname }) => (
    <TransitionMotion
        styles={ [{
            key: pathname,
            style: getStyles(),
            data: { child }
        }] }
        willEnter={ willEnter }
        willLeave={ willLeave }
    >
        { (interpolated) =>
            <div>
                { interpolated.map(({ key, style, data }) =>
                    <div
                        key={ `${key}-transition` }
                        style={ {
                            ...styles.wrapper,
                            opacity: style.opacity,
                            transform: `translateX(${style.offset}%)`
                        } }
                    >
                        { data.child }
                    </div>
                ) }
            </div>
        }
    </TransitionMotion>
);

var styles = {
    wrapper: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        overflow: 'auto',
    }
};

export default RouteTransition;


// WEBPACK FOOTER //
// ./app/components/RouteTransition/index.jsx